import React from 'react';
import './account-management.css';
import PropTypes from 'prop-types';
import {
    injectIntl,
    defineMessages,
    FormattedMessage,
    // useIntl
} from 'react-intl';
import {compose} from 'redux';
import copyIcon from '../lib/assets/icon--copy.png';
// import {getIsLogged} from '../../reducers/user-state.js';
import {requestUserInfo, requestUpdateAccount} from '../lib/api/login.js';
import Select from 'react-select';
import {connect} from 'react-redux';
import CustomModal from '../containers/custom-modal.jsx';
import bindAll from 'lodash.bindall';
// import {toast} from 'react-hot-toast';
import {Input, message} from 'antd';
import modalHeadBack from '../lib/assets/modalWifi.png'


const messages = defineMessages({
    myTitle: {
        defaultMessage: "Account Management",
        description: "Menu bar item for account management",
        id: "meun-item-account-accountManagement"
    }
})
class AccountManagement extends React.Component {
    constructor (props) {
        super(props);
        this.options = [
            {
                label: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.family',
                    defaultMessage: 'Family'
                }),
                // label: '家庭',
                name: 'family',
                value: 0
            },
            {
                label: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.organization',
                    defaultMessage: 'Organization'
                }),
                // label: '机构',
                name: 'organization',
                value: 1
            },
            {
                label: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.infantSchool',
                    defaultMessage: 'Infant School'
                }),
                // label: '幼儿园',
                name: 'infantSchool',
                value: 2
            },
            {
                // label: '小学',
                label: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.primarySchool',
                    defaultMessage: 'Primary School'
                }),
                name: 'primarySchool',
                value: 3
            }
        ];
        this.state = {
            mobile: '',
            nickname: '',
            address: '',
            email: '',
            serviceAuthCode: '',
            curOption: this.options[0]
        };
        this.tmpValueRef = React.createRef(null);

        bindAll(this, [
            'handleCopyText',
            'requestAccountManagement',
            'handleChangeOption',
            'handleFocusAccountInfo'
        ]);

        this.infoList = [
            {
                key: 'mobile',
                label: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.phone',
                    defaultMessage: 'Phone'
                }),
                // label: '手机号',
                // placeholder: '暂未绑定',
                placeholder: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.phonePlaceHolder',
                    defaultMessage: 'Not yet bound'
                }),
                // disabled: this.props.mode === 'mobile'
                disabled: true,
                maxLength: 30
            },
            {
                key: 'familyType',
                // label: '用户类型',
                // placeholder: '请选择类型',
                label: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.accountType',
                    defaultMessage: 'Type'
                }),
                placeholder: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.familyTypePlaceHolder',
                    defaultMessage: 'Select your family type'
                }),
                disabled: false
            },
            {
                key: 'nickname',
                // label: '姓名',
                // placeholder: '请输入姓名',
                label: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.name',
                    defaultMessage: 'Name'
                }),
                placeholder: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.namePlaceHolder',
                    defaultMessage: 'Enter your name'
                }),
                disabled: false,
                maxLength: 20
            },
            {
                key: 'address',
                // label: '地址',
                // placeholder: '请输入地址',
                label: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.address',
                    defaultMessage: 'Address'
                }),
                placeholder: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.addressPlaceHolder',
                    defaultMessage: 'Address'
                }),
                disabled: false,
                maxLength: 100
            },
            {
                key: 'email',
                // label: '邮箱',
                // placeholder: '未绑定',
                label: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.email',
                    defaultMessage: 'Email'
                }),
                placeholder: this.props.intl.formatMessage({
                    id: 'gui.accountManagement.emailPlaceHolder',
                    defaultMessage: 'Not yet bound'
                }),
                // disabled: this.props.mode === 'email'
                disabled: true,
                maxLength: 30
            }
        ];
    }

    componentDidMount () {
        this.requestAccountManagement();
    }

    /**
     * 请求账户信息
     */
    async requestAccountManagement () {
        // if (!getIsLogged(this.props.loginState)) return;
        await new Promise((resolve, reject) => {
            requestUserInfo(resolve, reject);
        }).then(rsp => {
            const {mobile, type, nickname, email, authCode, address} = rsp.data;
            this.setState({
                mobile,
                curOption: this.options[type],
                nickname,
                address: address,
                email: email,
                serviceAuthCode: authCode
            });
        });
    }

    /**
     * Handles updating account information
     * @param {string} key - The key of the state property to update
     * @returns {function} - An event handler that updates the state with the new value
     */
    handleChangeAccountInfo (key) {
        return e => {
            const {value} = e.target;
            this.tmpValueRef.current = this.state[key];
            this.setState({
                [key]: value
            });
        };
    }

    // 临时保存value的值
    handleFocusAccountInfo (key){
        return () => {
            this.tmpValueRef.current = this.state[key];
        };
    }

    /**
     * handles on blur event
     * @param {string} key - The key of the state property to update
     * @returns {function} - An event handler that when the input is blurred, request to update the state with the new value
     */
    handleBlurAccountInfo (key) {
        const validatePhoneNumber = phoneNumber => {
            const pattern = /^\d{10,11}$/;
            return pattern.test(phoneNumber);
        };
        const validateEmail = email => {
            const pattern = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+$/;
            return pattern.test(email);
        };
        return async e => {
            let {value} = e.target;
            value = value.trim();
            // 如果值没有改变，不需要请求
            if (value === this.tmpValueRef.current) return;
            switch (key) {
            case 'mobile':
                // 验证手机号码
                if (!validatePhoneNumber(value)) {
                    message.error('Invalid phone number');
                    return;
                }
                break;
            case 'email':
                // 验证邮箱
                if (!validateEmail(value)) {
                    message.error('Invalid email address');
                    return;
                }
                break;
            }
            const data = {
                [key]: value
            };
            await new Promise((resolve, reject) => {
                requestUpdateAccount(resolve, reject, data);
            });
            this.tmpValueRef.current = value;
            message.success(
                // '更新成功'
                this.props.intl.formatMessage({id: 'gui.aiproject.updateSuccess', defaultMessage: 'Update Successfully'})
            );
        };
    }

    /**
     * copy text handle
     * @param {*} val  - copy text
     */
    async handleCopyText () {
        const val = this.state.serviceAuthCode;
        if (navigator.clipboard && navigator.permissions) {
            await navigator.clipboard.writeText(val);
        } else {
            const textArea = document.createElement('textArea');
            textArea.value = val;
            textArea.style.width = 0;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999px';
            textArea.style.top = '10px';
            textArea.setAttribute('readonly', 'readonly');
            document.body.appendChild(textArea);

            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }
        message.success(
            this.props.intl.formatMessage({
                id: 'gui.account.serviceAuthCodeCopyToast',
                defaultMessage: 'Copy To Clipboard Successfully'
            })
            // '复制成功'
        );
    }

    async handleChangeOption (selectedOption) {
        this.setState({
            curOption: selectedOption
        });
        await new Promise((resolve, reject) => {
            requestUpdateAccount(resolve, reject, {
                type: selectedOption.value
            });
        });
        message.success(
            // '更新成功'
            this.props.intl.formatMessage({id: 'gui.aiproject.updateSuccess', defaultMessage: 'Update Successfully'})
        );
    }

    render () {
        const selectStyles = {
            control: base => ({
                ...base,
                width: '200px',
                height: '36px',
                cursor: 'pointer',
                boxShadow: 'none',
                border: '1px solid hsla(0, 0%, 96%, 1)',
                // background: '#F5F5F5',
                minHeight: 'fit-content',
                borderRadius: '18px',
                padding: '0'
            }),
            indicatorsContainer: base => ({
                ...base,
                height: '36px'
            }),
            indicatorSeparator: () => ({
                border: 'none'
            }),
            dropdownIndicator: base => ({
                ...base,
                padding: '0',
                width: '36px'
            })
        };
        return (
            <CustomModal
                className="modalSize modal"
                hasHeaderLine={false}
                headerImageTop={modalHeadBack}
                contentLabel={this.props.intl.formatMessage(messages.myTitle)}
                id="accountManagementModal"
                onRequestClose={this.props.onRequestClose}
            >
                <div className="container">
                    {this.infoList.map(item => (
                        <div
                            className="row"
                            key={item.key}
                        >
                            <div className="label">{item.label}</div>
                            {item.key === 'familyType' ? (
                                <Select
                                    classNames={{
                                        control: state =>
                                            (state.isFocused ?
                                                'border-red-600' :
                                                'border-grey-300')
                                    }}
                                    styles={selectStyles}
                                    className="familyTYpeSelect"
                                    options={this.options}
                                    value={this.state.curOption}
                                    onChange={this.handleChangeOption}
                                />
                            ) : (
                                <Input
                                    // {...props}
                                    onChange={this.handleChangeAccountInfo(item.key)}
                                    onBlur={this.handleBlurAccountInfo(item.key)}
                                    placeholder={item.placeholder}
                                    maxLength={item.maxLength}
                                    className={item.disabled ? "inputDisabled" : "inputEnable"}
                                    disabled={item.disabled}
                                    value={this.state[item.key]}
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onPressEnter={e => {
                                        e.target.blur();
                                    }}
                                />
                            )}
                        </div>
                    ))}
                    <div className="serviceAuthCodeDiv">
                        <div className="label">
                            <FormattedMessage
                                id="gui.account.serviceAuthCode"
                                defaultMessage="Service Auth Code"
                            />
                            {/* 云服务授权码 */}
                        </div>
                        <div className="serviceAuthCodeInput">
                            <span>{this.state.serviceAuthCode}</span>
                            <img
                                onClick={this.handleCopyText}
                                className="copyIcon"
                                src={copyIcon}
                                alt=""
                            />
                        </div>
                        <div className="serviceAUthCodeTips">
                            <FormattedMessage
                                id="gui.account.serviceAuthCodeTips"
                                defaultMessage="Your unique authorization code has been generated. Giving it to someone else will use up your cloud service call."
                            />
                            {/* 您的唯一授权码已生成，提供给他人会占用您的云服务调用 */}
                        </div>
                    </div>
                </div>
            </CustomModal>
        );
    }
}

AccountManagement.propTypes = {
    // intl: intlShape.isRequired,
    // isShow: PropTypes.bool.isRequired
    onRequestClose: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    // loginState: PropTypes.any,
    mode: PropTypes.string
};

const mapStateToProps = state => ({
    // loginState: state.scratchGui.userState.loginState,
    // mode: state.scratchGui.userState.mode
});

// const mapDispatchToProps = dispatch => ({});

// export default injectIntl(connect(mapStateToProps)(AccountManagement));
export default compose(
    injectIntl
)(AccountManagement);
// export default AccountManagement;